import classNames from "classnames";

type SortButtonProps = {
  label: string;
  columnKey: string;
  sort: "ASC" | "DESC" | null;
  onClick: () => void;
};

const SortButton = ({ label, sort, onClick }: SortButtonProps) => {
  const getLabel = () => {
    if (sort === "DESC") {
      return `Sort by ${label.toLowerCase()} in descending order`;
    } else if (sort === "ASC") {
      return `Sort by ${label.toLowerCase()} in ascending order`;
    }

    return `Sort by ${label.toLowerCase()}`;
  };

  return (
    <button
      className={classNames(
        "inline-flex h-[50px] items-center gap-[12px] p-[12px]",
        "rounded-[0] transition-[background-color,box-shadow,color,border-color] duration-200 ease-in-out hover:bg-[#E8E8EB]",
        "focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-black-rock"
      )}
      aria-pressed={sort ? "true" : "false"}
      aria-label={getLabel()}
      onClick={onClick}
    >
      <span
        className={
          "whitespace-nowrap font-bold text-[14px] leading-[130%] text-mono-40"
        }
      >
        {label}
      </span>
      <span className={"text-mono-30"}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M1 8L6 3L11 8"
            stroke="currentColor"
            data-dir="ASC"
            data-testid={"sortButton__arrow_ASC"}
            className={classNames("transition-[stroke]", {
              "stroke-black-rock": sort === "ASC",
            })}
            strokeWidth="2"
          />
          <path
            d="M23 16L18 21L13 16"
            stroke="currentColor"
            data-dir="DESC"
            data-testid={"sortButton__arrow_DESC"}
            className={classNames("transition-[stroke]", {
              "stroke-black-rock": sort === "DESC",
            })}
            strokeWidth="2"
          />
          <path
            d="M6 3V17"
            data-dir="ASC"
            stroke="currentColor"
            data-testid={"sortButton__arrow_ASC"}
            className={classNames("transition-[stroke]", {
              "stroke-black-rock": sort === "ASC",
            })}
            strokeWidth="2"
          />
          <path
            d="M18 21L18 7"
            data-dir="DESC"
            stroke="currentColor"
            data-testid={"sortButton__arrow_DESC"}
            className={classNames("transition-[stroke]", {
              "stroke-black-rock": sort === "DESC",
            })}
            strokeWidth="2"
          />
        </svg>
      </span>
    </button>
  );
};

export default SortButton;
